import { useWindowDimensions } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

/**
 * Fills a nested sheet — the same `insets.top` its `BottomSheetModal` is capped
 * by, so the screen and the sheet can't drift apart. A `FlowSheet` step waives
 * that cap (`topInset={0}`) and takes the whole window instead.
 */
export function useNestedSheetHeight() {
  const { height } = useWindowDimensions()
  const insets = useSafeAreaInsets()
  return height - insets.top
}

/**
 * Fills a `FlowSheet` step, which waives that cap (`topInset={0}`) and spans
 * the whole window — so the step owes the inset its sheet no longer pays.
 * Without it the first thing a step draws, the back disc, sits under the
 * status bar.
 */
export function useFlowStepFrame() {
  const { height } = useWindowDimensions()
  const insets = useSafeAreaInsets()
  return { height, paddingTop: insets.top }
}
